import "./TheStudio.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import WorkPortfolio from "./sections/WorkPortfolio";
import ContactForm from "./sections/ContactForm";
import Footer from "@/reusable_sections/Footer";
import Cards from "./sections/Cards";
export default function TheStudioPage() {
  return <div>
      <Header />
      <OurStory />
      <Cards />
      <WorkPortfolio />
      <ContactForm />
      <Footer />
    </div>;
}